import type {FC} from 'react';
import {CommonLink} from '../../../shared/components/CommonLink';

type Props = {
  textClassName: string;
  linkClassName: string;
};

export const RegisterTocNew: FC<Props> = ({textClassName, linkClassName}) => {
  return (
    <>
      <p className={`${textClassName} text-left`}>◆1.会員登録について◆</p>
      <ul className={`${textClassName} text-left`}>
        <li>
          1-1.
          <CommonLink href="#a1" className={linkClassName}>
            会員登録をしたい
          </CommonLink>
        </li>
        <li>
          1-2.
          <CommonLink href="#a2" className={linkClassName}>
            大学発行のメールアドレスを持っていない場合の学生確認方法
          </CommonLink>
        </li>
        <li>
          1-3.
          <CommonLink href="#a3" className={linkClassName}>
            新規会員登録画面で「そのメールアドレスはすでに登録されています」と表示される
          </CommonLink>
        </li>
        <li>
          1-4.
          <CommonLink href="#a4" className={linkClassName}>
            本登録用URLが記載されたメールが届かない
          </CommonLink>
        </li>
        <li>
          1-5.
          <CommonLink href="#a5" className={linkClassName}>
            大学メールアドレスを後から追加登録したい
          </CommonLink>
        </li>
        <li>
          1-6.
          <CommonLink href="#a6" className={linkClassName}>
            既卒だが会員登録をしたい
          </CommonLink>
        </li>
        <li>
          1-7.
          <CommonLink href="#a7" className={linkClassName}>
            学生証確認の結果、他の会員と重複していると言われた
          </CommonLink>
        </li>
      </ul>
    </>
  );
};
